<template>
  <AtomTransitionGroup
    class="flex flex-col gap-6 justify-center items-center w-full fixed bottom-0 left-0 p-4 pointer-events-none z-10002"
    variant="slide-up"
    tag="div"
  >
    <TToast
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :variant="toast.variant"
    />
  </AtomTransitionGroup>
</template>

<script setup lang="ts">
const { toasts } = useToast()
</script>
